import './Plug.scss';

export const Plug = () => {

  return (
    <section className="plug">
      <div className="container">
        <div className="plug__container">
          <div className="plug__container--text">OOooops :( <br /> This page is under development...</div>
        </div>
      </div> 
    </section>
  );
}